@if (open) {
  <div class="dialog-backdrop" (click)="close()">
    <div class="dialog-content" (click)="$event.stopPropagation()">
      <button type="button" class="dialog-close-btn" (click)="close()" aria-label="Close dialog">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>

      <div class="dialog-header">
        <ng-content select="[dialog-header]"></ng-content>
      </div>

      <div class="dialog-body">
        @if (contentTemplate) {
          <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        } @else {
          <ng-content select="[dialog-body]"></ng-content>
        }
      </div>
    </div>
  </div>
}

